module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'zz4h5flt',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
